import React from 'react';

const DoctorCalendar = React.lazy(() => import('pages/DoctorCalendar/DoctorCalendar'));
const DoctorCalendarAdd = React.lazy(() => import('pages/DoctorCalendar/DoctorCalendarAdd'));

const galleryRoute = [
  {
    path: '/doctor-calendar',
    exact: true,
    name: 'Danh sách lịch làm việc',
    function: 'CRM_DOCTOR_CALENDAR_VIEW',
    component: DoctorCalendar,
  },
  {
    path: '/doctor-calendar/add',
    exact: true,
    name: 'Thêm mới lịch làm việc',
    function: 'CRM_DOCTOR_CALENDAR_ADD',
    component: DoctorCalendarAdd,
  },
  {
    path: '/doctor-calendar/edit/:calendar_id',
    exact: true,
    name: 'Chỉnh sửa lịch làm việc',
    function: 'CRM_DOCTOR_CALENDAR_EDIT',
    component: DoctorCalendarAdd,
  },
  {
    path: '/doctor-calendar/detail/:calendar_id',
    exact: true,
    name: 'Chi tiết lịch làm việc',
    function: 'CRM_DOCTOR_CALENDAR_VIEW',
    component: DoctorCalendarAdd,
  },
];

export default galleryRoute;
